module.exports = __webpack_public_path__ + "static/media/line-chart.d7268027.svg";